 import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import EventsProgramsMailsEditView from "./events_programs_mails-edit.html";


angular.module("events_programs_mails", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('events_programs_mails', {
                url: "/events_programs_mails",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })
            .state('events_programs_mails.edit', {
                url: "/edit",
                controller: "EventsProgramsMailsEditCtrl",
                template: EventsProgramsMailsEditView,
            })
    }])
;